<template>
  <a-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel">
    <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
            <a-col :span="24" >
            <a-form-item label="考试类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['examType']" placeholder="请输入考试类型" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item label="考试名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['examName']" placeholder="请输入考试名称" ></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24" >
            <a-form-item label="时段试卷 开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择时段试卷 开始时间" v-decorator="['limitStartTime']" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item label="时段试卷 结束时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择时段试卷 结束时间" v-decorator="['limitEndTime']" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>

          <a-col :span="24" >
            <a-form-item label="试卷说明" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['comment']" placeholder="请输入试卷说明" ></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="24" >
            <a-form-item label="建议时长(分钟)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['suggestTime']" placeholder="请输入建议时长(分钟)" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item label="是否允许重复提交，1：允许，2：不允许" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['allowRepeat']" placeholder="请输入是否允许重复提交，1：允许，2：不允许" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item label="是否允许提前交卷，2：不允许" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['allowEarlier']" placeholder="请输入是否允许提前交卷，2：不允许" style="width: 100%" />
            </a-form-item>
          </a-col> -->

        </a-row>
      </a-form>
  </a-modal>
</template>

<script>

  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'

  export default {
    name: 'TestModal',
    components: {
      
    },
    data() {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        title:'',
        width:800,
        visible: false,
        disableSubmit: false,
        url: {
          add: "/exercise/elinkxExam/add",
          edit: "/exercise/elinkxExam/edit",
          queryById: "/exercise/elinkxExam/queryById",
        }
      }
    },
    methods:{
      add () {
        this.visible=true
        this.edit({});
      },
      edit (record) {
        this.visible=true
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'delFlag','name','pId','subject','sysSign','type'))
		  //时间格式化
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            //时间格式化
            
            console.log(formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      }
    }
  }
</script>

<style scoped>
</style>